import script from "./UserCart.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCart.vue?vue&type=script&setup=true&lang=js"

import "./UserCart.vue?vue&type=style&index=0&id=43f1f961&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43f1f961"]])

export default __exports__